var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7348 3.30208C13.8414 3.22135 14 3.29688 14 3.42448V8.75C14 9.4401 13.4121 10 12.6875 10H1.3125C0.587891 10 0 9.4401 0 8.75V3.42708C0 3.29688 0.155859 3.22396 0.265234 3.30469C0.877734 3.75781 1.68984 4.33333 4.47891 6.26302C5.05586 6.66406 6.0293 7.50781 7 7.5026C7.97617 7.51042 8.96875 6.64844 9.52383 6.26302C12.3129 4.33333 13.1223 3.75521 13.7348 3.30208ZM7 6.66667C7.63438 6.67708 8.54766 5.90625 9.00703 5.58854C12.6355 3.08073 12.9117 2.86198 13.7484 2.23698C13.907 2.11979 14 1.9375 14 1.74479V1.25C14 0.559896 13.4121 0 12.6875 0H1.3125C0.587891 0 0 0.559896 0 1.25V1.74479C0 1.9375 0.0929687 2.11719 0.251563 2.23698C1.08828 2.85937 1.36445 3.08073 4.99297 5.58854C5.45234 5.90625 6.36562 6.67708 7 6.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.ae5502eb2cc9958ded519d9f7628b963.svg";
export { ForwardRef as ReactComponent };